/* Approved option names select approved diagrams. Never changes offers/cart. */
(() => {
  const normalize = value => String(value).trim().toLowerCase().replace(/\s+/g, ' ');
  function aliasId(value, data) {
    const normalized = normalize(value);
    if (data.aliases[normalized]) return data.aliases[normalized];
    const matches = Object.keys(data.aliases)
      .filter(alias => normalized.startsWith(alias + ' ') || normalized.startsWith(alias + '/') || normalized.startsWith(alias + '('))
      .sort((left, right) => right.length - left.length);
    return matches.length ? data.aliases[matches[0]] : null;
  }
  function sizeId(variant, data) {
    if (Object.hasOwn(data.overrides, String(variant.id))) return data.overrides[String(variant.id)];
    const matches = [...new Set(variant.options.map(value => aliasId(value, data)).filter(Boolean))];
    return matches.length === 1 ? matches[0] : null;
  }
  function stockRow(variant) {
    const stock = document.createElement('div');
    stock.className = 'osn-container-stock';
    stock.dataset.stockState = variant.available ? 'available' : 'unavailable';
    const status = document.createElement('span');
    status.textContent = variant.available ? 'In stock' : 'Currently unavailable';
    stock.append(status);
    if (variant.available && variant.inventoryManagement === 'shopify' && Number(variant.inventoryQuantity) > 0) {
      const count = document.createElement('strong'); count.textContent = `${variant.inventoryQuantity} available`; stock.append(count);
    }
    return stock;
  }
  function card(id, data, variant = null) {
    const form = data.forms[id], article = document.createElement('div');
    article.className = 'osn-container-card'; article.dataset.containerId = id;
    const art = document.createElement('div'); art.className = 'osn-container-art'; art.innerHTML = form.svg;
    const copy = document.createElement('div');
    for (const [tag, text] of [['h3', form.name], ['strong', form.dimensions]]) {
      const node = document.createElement(tag); node.textContent = text; copy.append(node);
    }
    const notes = document.createElement(variant ? 'details' : 'div');
    if (variant) {
      notes.className = 'osn-container-notes';
      const summary = document.createElement('summary'); summary.textContent = 'About this size'; notes.append(summary);
    }
    for (const [tag, text] of [['p', form.growth_context], ['p', form.copy]]) {
      if (!text) continue;
      const node = document.createElement(tag); node.textContent = text; notes.append(node);
    }
    copy.append(notes);
    if (variant) article.append(stockRow(variant));
    article.append(art, copy); return article;
  }
  function stockOnlyCard(variant) {
    const article = document.createElement('div');
    article.className = 'osn-container-card osn-container-card--stock-only';
    article.append(stockRow(variant));
    return article;
  }
  async function mount(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const response = await fetch(root.dataset.sizeSource);
    if (!response.ok) throw new Error('Size guide unavailable');
    const data = await response.json();
    const variants = JSON.parse(root.querySelector('[data-size-variants]').textContent);
    const product = document.getElementById('MainProduct-' + root.dataset.sectionId);
    if (!product) return;
    const ids = [...new Set(variants.map(v => sizeId(v, data)).filter(id => data.forms[id]))];
    const selected = root.querySelector('[data-selected-container]');
    const compare = root.querySelector('[data-container-comparison]');
    for (const id of ids) root.querySelector('[data-container-options]').append(card(id,data));
    compare.hidden = ids.length < 2;
    const render = () => {
      const radios = product.querySelector('variant-radios');
      const choices = radios ? [...radios.querySelectorAll('fieldset')].map(f => f.querySelector('input:checked')?.value) : [...product.querySelectorAll('variant-selects select')].map(s=>s.value);
      const candidate = choices.length ? variants.find(v => v.options.every((value,i)=>value===choices[i])) : variants.find(v=>String(v.id)===root.dataset.selectedVariant);
      const id = candidate && sizeId(candidate,data);
      root.hidden = !candidate;
      if (root.hidden) { selected.replaceChildren(); return; }
      const inventorySignature = `${candidate.id}:${candidate.available}:${candidate.inventoryManagement}:${candidate.inventoryQuantity}`;
      if (selected.firstElementChild?.dataset.inventorySignature !== inventorySignature) {
        const selectedCard = data.forms[id] ? card(id, data, candidate) : stockOnlyCard(candidate);
        selectedCard.dataset.inventorySignature = inventorySignature;
        selected.replaceChildren(selectedCard);
      }
      root.dataset.currentVariant = String(candidate.id);
    };
    product.addEventListener('change', render);
    render();
  }
  if (!document.getElementById('osn-container-style')) {
    const style = document.createElement('style'); style.id = 'osn-container-style';
    style.textContent = `
      [data-osn-container-size]{margin:16px 0;max-width:100%;color:#233c30}
      [data-osn-container-size][hidden],[data-container-comparison][hidden]{display:none!important}
      .osn-container-card{display:grid;grid-template-columns:100px minmax(0,1fr);gap:12px;align-items:center;background:#f5f5ed;border:1px solid #d8dfd2;border-radius:6px;padding:12px;margin:10px 0}
      .osn-container-art svg{width:100%;height:auto;max-height:140px}
      .osn-container-card h3{font-size:17px;line-height:1.3;margin:0 0 6px}
      .osn-container-card p{font-size:15px;line-height:1.5;margin:6px 0}
      .osn-container-card strong{font-size:16px}
      .osn-container-card .osn-container-stock{grid-column:1/-1;display:flex;justify-content:space-between;align-items:center;gap:8px;flex-wrap:wrap;margin:-12px -12px 0;padding:12px 14px;border-radius:5px 5px 0 0;border-bottom:1px solid #c9d9ca;background:#e6f0e5;color:#173f29;font-size:16px;line-height:1.4;font-weight:600}
      .osn-container-card--stock-only{display:block;padding:0;background:transparent;border:0}
      .osn-container-card--stock-only .osn-container-stock{margin:0;border:1px solid #c9d9ca;border-radius:6px}
      .osn-container-stock span{display:flex;align-items:center;gap:8px}
      .osn-container-stock span::before{content:'';width:8px;height:8px;border-radius:50%;background:currentColor;flex:none}
      .osn-container-stock strong{font-size:17px;font-weight:700;white-space:nowrap}
      .osn-container-stock[data-stock-state='unavailable']{background:#eeeae3;color:#50473a;border-color:#dcd4c7}
      .osn-container-notes{margin-top:4px}
      .osn-container-notes summary{display:list-item;min-height:44px;padding:12px 0;box-sizing:border-box;font-size:14px;line-height:20px;font-weight:600;color:#275c3b;cursor:pointer;text-decoration:underline;text-underline-offset:3px}
      .osn-container-notes summary:focus-visible{outline:2px solid #275c3b;outline-offset:3px}
      [data-container-comparison] summary{padding:12px 0;min-height:44px;cursor:pointer;font-size:15px}
      @media(max-width:380px){.osn-container-card{grid-template-columns:85px minmax(0,1fr);gap:10px}}
    `;
    document.head.append(style);
  }
  document.querySelectorAll('[data-osn-container-size]').forEach(root => mount(root).catch(()=>{root.hidden=true;delete root.dataset.initialized;}));
})();
